import { EMPTY_OBJECT } from '../../../../../constants/common'
import { getRentalPortalProfileTabCount } from '../../../RentalPortal.utils'

export function getListingProfileTabCounters(listingData) {
  return Object.entries(listingData?.counts || EMPTY_OBJECT).reduce(
    (acc, [section, total]) => {
      acc[section] = { total: getRentalPortalProfileTabCount(total) }

      return acc
    },
    {}
  )
}
